import type { RawAxiosRequestHeaders } from "axios";
import type { ApiResponse } from "../factory";
import { BaseRepository } from "../factory";

export interface Pages {
  id: number;
  name: string;
  description: string | null;
  main_image_id: number | null;
  link: string;
  created_at: string;
  updated_at: string;
  contents: string;
  main_image: {
    data: [];
  };
}

export interface PageUpdate {
  contents: string;
}

export class PagesRepository extends BaseRepository<Pages, PageUpdate> {
  collection = "pages";
  language?: string;

  constructor(language?: string) {
    super();
    this.language = language;
  }

  update(
    id: number | string,
    data: PageUpdate,
    headers?: RawAxiosRequestHeaders
  ): Promise<ApiResponse<Pages>> {
    return super.update(id, data, headers);
  }

  public get(
    id: number | string,
    queryParams?: Record<string, unknown>,
    headers?: RawAxiosRequestHeaders
  ): Promise<ApiResponse<Pages>> {
    return super.get(id, queryParams, headers);
  }
}
